import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { CuentaBancaria } from '../../../models/cuenta-bancaria';
import { Pagination } from '../../../models/pagination';
import { CuentaBancariaService } from '../../../services/cuenta-bancaria.service';

@Component({
  selector: 'app-cuenta-bancaria-modal',
  templateUrl: './cuenta-bancaria-modal.component.html',
  styleUrls: ['./cuenta-bancaria-modal.component.css'],
  providers:[
    CuentaBancariaService
  ]
})
export class CuentaBancariaModalComponent implements OnInit {

  @Output() sendCuenta = new EventEmitter();

  public cuentas: Array<CuentaBancaria> = [];
  public selectedRow: Number;
  public pagination: Pagination;
  public loading = false;
  public format_decimal: String;
  public cuenta:CuentaBancaria;
  public busqueda:string;
  constructor(
    public cuentaService: CuentaBancariaService,
    public bsModalRef: BsModalRef,
  ) {
    this.cuentas = [];
    this.pagination = new Pagination();
    this.format_decimal = "0,0.00";
    this.cuenta = new CuentaBancaria();
    this.busqueda = "";
  }

  ngOnInit() {

    let p1 = this.getCuentas();
    this.loading = true;
    Promise.all([p1]).then(
      res => this.loading = false,
      err => this.loading = false
    );
  }

  getIndexNumber(i) {
		return this.pagination.from + i;
  }

  getCuentas(qs = "") {
    return new Promise((resolve, reject) => {
      this.cuentaService.getAll("?page=" + this.pagination.current_page + "&per_page=10"+qs+"&status=A" ).subscribe(
        res => {
          
          this.cuentas = res.data;

          this.pagination.current_page = res.current_page;
          this.pagination.from = res.from;
          this.pagination.to = res.to;
          this.pagination.total = res.total;
          this.pagination.last_page = res.last_page;
          this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
          this.pagination.prev_disabled = this.pagination.current_page === 1;
          resolve();
        },
        err => {
          this.cuentas = [];
          reject(err);
        }
      );
    });

  }

  getcuentasBySearch(text){
    this.busqueda = text;
    let qs = "";
    if (this.busqueda != "") {
       qs = this.getQs();
    }
    this.loading = true;
    let id = "";
    this.getCuentas(qs).then(
      res => this.loading = false,
      err => this.loading = false
    );
  }

  getQs(){
		return "&nombre=" + this.busqueda;
  }


  onSelectRow(cuenta, i) {
    //Asignacion de fila
    this.selectedRow = i;
    //Asignacion de usuario
    this.cuenta = cuenta;
  }

  onDBLClick(usuario, i) {
    this.onSelectRow(usuario, i);
    this.onSubmit();
  }

  onSubmit() {
    if (this.cuenta) {
      //envía de objecto usuario
      this.sendCuenta.emit(this.cuenta);
      this.bsModalRef.hide();
    } else {
      //Cierre de modal o componente
      this.bsModalRef.hide();
    }


  }

  next() {
    let qs = "";
		if(this.busqueda != ""){
			qs = this.getQs();
    }
    let id = "";
		this.pagination.current_page++;
		this.getCuentas(qs);
	}

	prev() {
    let qs = "";
		if(this.busqueda != ""){
			qs = this.getQs();
    }
    let id = "";
		this.pagination.current_page--;
		this.getCuentas(qs);
	}

	first() {
    let qs = "";
		if(this.busqueda != ""){
			qs = this.getQs();
    }
    let id = "";
		this.pagination.current_page = 1;
		this.getCuentas(qs);
	}

	last() {
    let qs = "";
		if(this.busqueda != ""){
			qs = this.getQs();
    }
    let id = "";
		this.pagination.current_page = this.pagination.last_page;
		this.getCuentas(qs);
	}

  

  get formatDecimal() {
    return this.format_decimal;
  }

  getTipo(tipo){
    return tipo == 'A'?'Ahorros':'Corriente';
  }

  getEstado(estado){
    return (estado=='A')?"Activa":"Inactiva";
  } 

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/cuenta-bancaria-modal/cuenta-bancaria-modal.component.ts